<template>
    <ul class="nav flex-column account-settings" role="tablist">
        <li class="col-12 py-3 border-bottom" v-for="item in tabs">
            <inertia-link
                :href="item.link"
                class="font-poppins color-blue font-size-18"
                :class="{ 'active' : isActive(item.name) }">
                {{ item.label }}
            </inertia-link>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        tab: String,
    },
    data() {
        return {
            tabs: [
                {
                    name: 'account',
                    label: Lang.get('employeedashboard::pages/settings/index.tabs.account'),
                    link: this.route('nl.employeedashboard.settings.account.show'),
                },
                {
                    name: 'changePassword',
                    label: Lang.get('employeedashboard::pages/settings/index.tabs.change_password'),
                    link: this.route('nl.employeedashboard.settings.account.change-password'),
                },
                {
                    name: 'preferredLanguage',
                    label: Lang.get('employeedashboard::pages/settings/index.tabs.preferred_language'),
                    link: this.route('nl.employeedashboard.settings.account.language.edit'),
                },
                {
                    name: 'twoFactorAuthentication',
                    label: Lang.get('employeedashboard::pages/settings/index.tabs.two_factor_authentication'),
                    link: this.route('nl.employeedashboard.settings.two-factor-authentication.index'),
                },
            ],
        }
    },
    methods: {
        isActive(tab) {
            return tab === this.tab;
        },
    },
}
</script>
